import $ from 'jquery';
import Slider from "../global/Slider";
import Section from '../Section';

export default class Slideshow extends Section {
  SLIDER_SELECTOR = '.swiper-container';
  SLIDER_REENABLE_INTERVAL = 6000; // ms

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.restartTimer = null;
    const sliderElement = element.querySelector(this.SLIDER_SELECTOR);
    this.speed = parseInt(sliderElement.dataset.sliderSlideTime, 10);

    this.slider = new Slider(theme, sliderElement, {
      speed: this.speed,
      animation: sliderElement.dataset.sliderAnimation,
      onSlideChange: this.onSlideChange,
    });
  }

  onSlideChange = () => {
    if (this.slider.isRunning && this.speed > 0) {
      // restart autoscroll after given interval since last interaction
      clearTimeout(this.restartTimer);
      this.restartTimer = setTimeout(() => {
        this.slider.start();
      }, Math.max(0, this.SLIDER_REENABLE_INTERVAL - this.speed));
    }

  }

  onBlockSelect = ({ element }) => {
    const index = parseInt(element.dataset.slideIndex, 0);
    this.slider.slideTo(index)
    this.slider.stop();
  }

  onBlockDeselect = () => {
    this.slider.start();
  }
}
